import React from "react";
import Input from "../../../../../../components/inputs/input";
import {
	getCurrentRangeValue,
	getRangeInputValue,
	getRangeMax,
	getRangeMin,
	getRangeProgress,
	getRangeStep,
	getRangeValueFromInput
} from "../../utils/form-range-utils";
import "./range.css";

const RangeField = ({
	field,
	value,
	onChange,
	className
}) => {
	const currentRangeValue = getCurrentRangeValue({
		field,
		value
	});

	const rangeProgress = getRangeProgress({
		field,
		value
	});

	const handleRangeChange = event => {
		const finalValue = getRangeValueFromInput({
			field,
			inputValue: event.target.value
		});

		onChange(field.name, finalValue);
	};

	return (
		<div className="form-generic__range-field">
			<span
				className="form-generic__range-value"
				style={{
					left: `${rangeProgress}%`
				}}
			>
				{currentRangeValue}
			</span>

			<Input
				className={className}
				name={field.name}
				label={field.label}
				type={field.type}
				value={getRangeInputValue({
					field,
					value
				})}
				placeholder={field.placeholder}
				onChange={handleRangeChange}
				disabled={field.disabled}
				min={getRangeMin(field)}
				max={getRangeMax(field)}
				step={getRangeStep(field)}
				width="100%"
				style={{
					"--range-progress": `${rangeProgress}%`
				}}
			/>
		</div>
	);
};

export default RangeField;